import { gql } from '@apollo/client'

export default gql`
  query lotsListQuery($marketId: Int!, $lotsOffset: Int, $lotsLimit: Int) {
    lots(
      filter: {
        marketId: $marketId
        active: true
        privateProperty: false
        or: [{ custom: false }, { locationsThisWeekGte: 1 }]
      }
      page: { limit: $lotsLimit, offset: $lotsOffset }
      sort: [
        { field: locations_this_week_count, direction: desc }
        { field: name, direction: asc }
      ]
    ) {
      total
      records {
        id
        address
        name
        lotUrl
        locationsThisDayCount
        locationsThisWeekCount
        foodImage {
          medium
          present
        }
      }
    }
  }
`
